import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  marketings: [],
};

const getters = {
  allMarketings: (state) => state.marketings,
};

const actions = {
  async fetchMarketings({ commit }, params = {}) {
    try {
      commit("resetMarketings");
      const response = await axios.get("/marketing", { params: prm(params) });
      commit("setMarketings", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch marketings:", error);
    }
  },
  async createMarketing({ commit }, marketing) {
    try {
      const response = await axios.post("/marketing", marketing);
      commit("addMarketing", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create marketing:", error);
      throw error;
    }
  },
  async fetchMarketingById(_, id) {
    try {
      const response = await axios.get(`/marketing/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch marketing:", error);
      throw error;
    }
  },
  async updateMarketing({ commit }, marketing) {
    try {
      const response = await axios.put(`/marketing/${marketing.id}`, marketing);
      commit("updateMarketing", response.data);
    } catch (error) {
      console.error("Failed to update marketing:", error);
      throw error;
    }
  },
  async deleteMarketingById({ commit }, id) {
    try {
      const response = await axios.delete(`/marketing/${id}`);
      commit("removeMarketing", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete marketing:", error);
      throw error;
    }
  },
};

const mutations = {
  setMarketings(state, marketings) {
    state.marketings = marketings.data; // Ensure this matches your API's response structure
  },
  addMarketing(state, marketing) {
    state.marketings.push(marketing);
  },
  updateMarketing(state, updatedMarketing) {
    const index = state.marketings.findIndex(
      (marketing) => marketing.id === updatedMarketing.id
    );
    if (index !== -1) {
      state.marketings.splice(index, 1, updatedMarketing);
    }
  },
  removeMarketing(state, id) {
    state.marketings = state.marketings.filter(
      (marketing) => marketing.id !== id
    );
  },
  resetMarketings(state) {
    state.marketings = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
